/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetCourseDetailOptions, GetCourseDetailStatus200, GetCourseDetailStatus422 } from '../models/GetCourseDetail'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getCourseDetail } from '../clients/axios/getCourseDetail'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCourseDetailQueryKey = ({ path }: Omit<GetCourseDetailOptions, 'headers'>) => [{ url: '/course/:course_id', params: path }] as const

type GetCourseDetailQueryKey = ReturnType<typeof getCourseDetailQueryKey>

export function getCourseDetailQueryOptions({ path }: GetCourseDetailOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getCourseDetailQueryKey({ path })
  return queryOptions<GetCourseDetailStatus200, ResponseErrorConfig<GetCourseDetailStatus422>, GetCourseDetailStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getCourseDetail({ ...config, path, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Course
 * {@link /course/:course_id}
 */
export function useGetCourseDetail<TData = GetCourseDetailStatus200, TQueryData = GetCourseDetailStatus200, TQueryKey extends QueryKey = GetCourseDetailQueryKey>({ path }: { path: GetCourseDetailOptions['path'] | (() => GetCourseDetailOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<GetCourseDetailStatus200, ResponseErrorConfig<GetCourseDetailStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getCourseDetailQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getCourseDetailQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetCourseDetailStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
